<form [formGroup]="form" (ngSubmit)="submit()" data-testid="event-builder-form">
  <mat-dialog-content
    class="dialog-content"
    role="dialog"
    aria-modal="true"
    aria-labelledby="event-builder-title"
  >
    <p id="event-builder-title" class="dialog-title">
      {{ isEditMode ? 'Edit Event' : 'New Event' }}
    </p>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Title</mat-label>
      <input
        matInput
        formControlName="title"
        placeholder="Event title"
        aria-label="Event title"
        data-testid="event-title-input"
      />
      <mat-error>Title is required</mat-error>
    </mat-form-field>

    <div class="row">
      <mat-form-field appearance="outline" class="grow">
        <mat-label>Date</mat-label>
        <input
          matInput
          [matDatepicker]="datePicker"
          formControlName="day"
          aria-label="Event date"
          data-testid="event-date-input"
          readonly
          (click)="datePicker.open()"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="datePicker"
          aria-label="Open calendar"
        ></mat-datepicker-toggle>
        <mat-datepicker #datePicker></mat-datepicker>
        <mat-error>Date is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="grow">
        <mat-label>Start time</mat-label>
        <input
          matInput
          formControlName="start_time"
          placeholder="10:00 AM"
          aria-label="Start time"
          data-testid="event-start-time-input"
          [matAutocomplete]="startTimeAuto"
        />
        <mat-autocomplete #startTimeAuto="matAutocomplete">
          @for (t of filterTimeOptions(form.get('start_time')?.value); track t) {
            <mat-option [value]="t">{{ t }}</mat-option>
          }
        </mat-autocomplete>
        @if (form.get('start_time')?.hasError('required')) {
          <mat-error>Start time is required</mat-error>
        } @else if (form.get('start_time')?.hasError('invalidTime')) {
          <mat-error>Enter a valid time, e.g. "10:30 AM"</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="grow">
        <mat-label>End time</mat-label>
        <input
          matInput
          formControlName="end_time"
          placeholder="11:00 AM"
          aria-label="End time (optional)"
          data-testid="event-end-time-input"
          [matAutocomplete]="endTimeAuto"
        />
        <mat-autocomplete #endTimeAuto="matAutocomplete">
          @for (t of filterTimeOptions(form.get('end_time')?.value); track t) {
            <mat-option [value]="t">{{ t }}</mat-option>
          }
        </mat-autocomplete>
        <mat-error>Enter a valid time, e.g. "11:00 AM"</mat-error>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Location</mat-label>
      <input
        matInput
        formControlName="place"
        placeholder="Optional"
        aria-label="Event location"
        data-testid="event-location-input"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description</mat-label>
      <textarea
        matInput
        formControlName="description"
        rows="3"
        placeholder="Optional"
        aria-label="Event description"
        data-testid="event-description-input"
        class="no-resize"
      ></textarea>
    </mat-form-field>

    @if (isCounselor) {
      <div class="share-row">
        <mat-slide-toggle
          formControlName="is_shared"
          aria-label="Share this event with students"
          data-testid="event-share-toggle"
        >
          Share with students
        </mat-slide-toggle>
      </div>

      @if (isShared) {
        <mat-form-field appearance="outline" class="full-width" data-testid="event-grades-select">
          <mat-label>Grade levels</mat-label>
          <mat-select formControlName="grades" multiple aria-label="Select grade levels">
            @for (g of gradeOptions; track g.value) {
              <mat-option [value]="g.value" [attr.data-testid]="'grade-option-' + g.value">{{
                g.label
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width" data-testid="event-groups-select">
          <mat-label>Groups</mat-label>
          <mat-select formControlName="groups" multiple aria-label="Select groups">
            @for (g of groups(); track g.id) {
              <mat-option [value]="g.id" [attr.data-testid]="'group-option-' + g.id">{{
                g.name
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    }
  </mat-dialog-content>

  @if (errorMessage) {
    <p class="error-msg" role="alert" data-testid="event-error-msg">{{ errorMessage }}</p>
  }

  <mat-dialog-actions align="end">
    @if (isEditMode) {
      <button
        mat-stroked-button
        color="warn"
        type="button"
        (click)="delete()"
        aria-label="Delete event"
        class="delete-btn"
        data-testid="event-delete-btn"
      >
        <mat-icon aria-hidden="true">delete</mat-icon> Delete
      </button>
    }
    <button
      mat-button
      mat-dialog-close
      type="button"
      aria-label="Cancel"
      data-testid="event-cancel-btn"
    >
      Cancel
    </button>
    <button
      mat-flat-button
      type="submit"
      [disabled]="form.invalid"
      aria-label="{{ isEditMode ? 'Save changes' : 'Create event' }}"
      class="submit-btn"
      data-testid="event-submit-btn"
    >
      {{ isEditMode ? 'Save' : 'Create' }}
    </button>
  </mat-dialog-actions>
</form>
